import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { FileRef } from "../model/fileDto";

@Injectable({
  providedIn: "root",
})
export class FileService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.api.basePath}/file`;

  /**
   * GET: Downloads a file as a Blob
   */
  getFileBlob(id: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${id}`, {
      responseType: "blob",
    });
  }

  getFileURL(file: FileRef | undefined): string | undefined {
    return file ? `${this.baseUrl}/${file.id}` : undefined;
  }

  /**
   * POST: Uploads/Sends data to the file endpoint
   */
  async uploadFile(file: File): Promise<FileRef> {
    const formData = new FormData();
    formData.append("file", file);

    return firstValueFrom(this.http.post<FileRef>(this.baseUrl, formData));
  }
}
